import React, {memo} from "react";
import { TRANSACTION_TYPE_ENUM } from "../../types/enums";
import { Transaction } from "../../providers/transactions.store";
import {TransactionHelper} from "../../helpers/transaction.helper";

interface TransactionDetailsProps {
    transaction: Transaction;
}

export const TransactionDetails: React.FC<TransactionDetailsProps> = memo(({ transaction }) => {
    const {
        transaction_type,
        network_provider,
        narration,
        reference_id,
        data_plan,
        cable_provider,
        cable_customer_name,
        disco_name,
        created,
        payment_type
    } = transaction;

    const transactionTypeDisplay = TransactionHelper.getTransactionTypeDisplay(transaction_type);

    const renderTransactionSpecificDetails = () => {
        switch (transaction_type) {
            case TRANSACTION_TYPE_ENUM.AIRTIME:
            case TRANSACTION_TYPE_ENUM.DATA_TOP_UP:
                return network_provider && (
                    <DetailRow label="Network:" value={network_provider} />
                );
            case TRANSACTION_TYPE_ENUM.CABLE_SUBSCRIPTION:
                return (
                    <>
                        {cable_provider && <DetailRow label="Provider:" value={cable_provider} />}
                        {cable_customer_name && (
                            <DetailRow label="Customer Name:" value={cable_customer_name} capitalize />
                        )}
                    </>
                );
            case TRANSACTION_TYPE_ENUM.ELECTRICITY:
                return disco_name && (
                    <DetailRow label="Disco:" value={disco_name} capitalize />
                );
            default:
                return null;
        }
    };

    return (
        <div className="second">
            <DetailRow label="Type:" value={transactionTypeDisplay} />

            {renderTransactionSpecificDetails()}

            {transaction_type === TRANSACTION_TYPE_ENUM.DATA_TOP_UP && data_plan && (
                <DetailRow label="Data Plan:" value={data_plan} />
            )}

            {narration && <DetailRow label="Description:" value={narration} />}
            {reference_id && <DetailRow allowValueSelectable label="Reference ID:" value={reference_id} mono />}
            {created && <DetailRow label="Date:" value={TransactionHelper.formatTransactionDate(created)} />}
            {payment_type && <DetailRow label="Payment Method:" value={TransactionHelper.formatPaymentType(payment_type)} />}
        </div>
    );
});

// Reusable detail row component
interface DetailRowProps {
    label: string;
    value: string;
    capitalize?: boolean;
    allowValueSelectable?: boolean;
    mono?: boolean;
}

const DetailRow: React.FC<DetailRowProps> = memo(({ label,allowValueSelectable,  value, capitalize, mono }) => (
    <div className="flex-between">
        <span className="flex-shrink-0">{label}</span>
        <span className={`text-end ${allowValueSelectable ? "select-all" : ''} ${capitalize ? 'text-capitalize' : ''} ${mono ? 'font-mono text-sm' : ''}`}>
      {value}
    </span>
    </div>
));